//Builds a CSV from an array of objects, whose keys are the attributes. e.g. [{id:1,supplierId:10, orderRef: "DEI1"}..]
export function objArrToCSV(arr) {
  const array = [Object.keys(arr[0])].concat(arr);
  return array
    .map(row => {
      return Object.values(row).toString();
    })
    .join("\n");
}
